import { Reducer } from "redux";

import { ReAuthDefaultServiceProviderActionDispatchTypes } from "../models/dispatchTypes/Referral";
import { ReAuthDefaultServiceProviderDispatchTypes } from "../constants/Referral";
import { ReAuthDefaultServiceProviderResponse } from "../models/api/Referral";

const initialState: ReAuthDefaultServiceProviderResponse = {
  loading: false,
  response: {
    serviceProviderId: 0,
    parentCompany: 0,
    symplrId: 0,
    serviceProviderUid: "",
    providerName: "",
    ahcccsId: "",
    medicareId: "",
    providerNpi: "",
    streetName1: "",
    streetName2: "",
    zipCode: "",
    providerCity: "",
    providerState: "",
    providerCounty: "",
    country: "",
    phone: "",
    extension: "",
    email: "",
    fax: "",
    contractEffectiveFrom: "",
    contractEffectiveTo: "",
    plexisOfficeId: 0,
    providerId: 0,
    taxId: "",
    userCreated: "",
    providerAddress: "",
    reimbursementTypeId: 0,
    reimbursementTypeName: "",
  },
  error: null,
};

const GetServiceProviderDetailsReducer: Reducer<
  ReAuthDefaultServiceProviderResponse,
  ReAuthDefaultServiceProviderActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReAuthDefaultServiceProviderDispatchTypes.RE_AUTH_DEFAULT_SERVICE_PROVIDER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReAuthDefaultServiceProviderDispatchTypes.RE_AUTH_DEFAULT_SERVICE_PROVIDER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReAuthDefaultServiceProviderDispatchTypes.RE_AUTH_DEFAULT_SERVICE_PROVIDER_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case ReAuthDefaultServiceProviderDispatchTypes.RE_AUTH_DEFAULT_SERVICE_PROVIDER_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GetServiceProviderDetailsReducer;
